import React from "react";
interface IProps {
  item?: any;
  fieldName: string;
  caption: string;
}
export const NFLookupCatalogColumn = React.memo(
  ({ item, fieldName, caption }: IProps) => {
    return (
      <>
        {item && <td>{item[fieldName]}</td>}
        {!item && <th>{caption}</th>}
      </>
    );
  }
);
